import React, { useEffect, useState, useContext } from "react";
import { Row, Col, Card, CardBody, CardHeader, Input } from "reactstrap";
import { Link } from "react-router-dom";
// import * as TBToolkit from "react-bootstrap-table2-toolkit";
// const ToolkitProvider = TBToolkit.default;
// const { Search } = TBToolkit;
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import { useLazyQuery, useQuery } from "@apollo/client";
import {
  GET_ORGANISATIONS,
  GET_RECENTFAILED_BY_ORG,
  GET_RECENTFAILED_MESSAGES,
} from "./messages.query";
import Select from "react-select";
import { ThemeContext } from "src/helpers/themeContext";
import { mapMessagesToTableData, parseDateTime } from "./messageUtils";
import "./shared-table.scss";

const RecentFailedMessages = () => {
  const Theme = useContext(ThemeContext);
  const [tableData, setTableData] = useState<any>([]);
  const [orgs, setOrgs] = useState<any>([]);
  const [selectedOrg, setSelectedOrg] = useState<any>({
    label: "All Organisations",
    value: -1,
  });
  const [searchText, setSearchText] = useState("");

  const columns = [
    {
      dataField: "Id",
      text: "ID",
      sort: true,
      headerStyle: { textAlign: "left", width: "80px" } as React.CSSProperties,
      style: { textAlign: "left" } as React.CSSProperties,
    },
    {
      dataField: "CreatedOn",
      text: "Date/time",
      sort: true,
      headerStyle: { textAlign: "left", width: "160px" } as React.CSSProperties,
      style: { textAlign: "left" } as React.CSSProperties,
      sortFunc: (a: string, b: string, order: string) => {
        const dateA = parseDateTime(a);
        const dateB = parseDateTime(b);
        if (order === "asc") {
          return dateA - dateB;
        }
        return dateB - dateA;
      },
    },
    {
      dataField: "OrgName",
      text: "Organisation",
      sort: true,
      headerStyle: {
        textAlign: "left",
        width: "140px",
      } as React.CSSProperties,
      style: { textAlign: "left" } as React.CSSProperties,
    },
    {
      dataField: "Inbox",
      text: "Inbox",
      sort: true,
      headerStyle: { textAlign: "left", width: "120px" } as React.CSSProperties,
      style: { textAlign: "left" } as React.CSSProperties,
    },
    {
      dataField: "Contact",
      text: "Contact",
      sort: true,
      headerStyle: { textAlign: "left", width: "120px" } as React.CSSProperties,
      style: { textAlign: "left" } as React.CSSProperties,
    },
    {
      dataField: "SendFailureReason",
      text: "Failure Reason",
      sort: true,
      headerStyle: { textAlign: "left" } as React.CSSProperties,
      style: { textAlign: "left", whiteSpace: "normal" } as React.CSSProperties,
    },
  ];

  const defaultSorted: [{ dataField: string; order: "asc" | "desc" }] = [
    {
      dataField: "Id",
      order: "desc",
    },
  ];

  const pageOptions = {
    sizePerPage: 10,
    totalSize: tableData.length,
    custom: true,
    showTotal: true,
    paginationTotalRenderer: (from: number, to: number, size: number) => {
      return (
        <span className="react-bootstrap-table-pagination-total">
          Showing {from} to {to} of {size} Results
        </span>
      );
    },
  };

  const { data, refetch } = useQuery(GET_RECENTFAILED_MESSAGES, {
    fetchPolicy: "no-cache",
  });

  const { data: orgData, refetch: refetchOrgData } = useQuery(
    GET_ORGANISATIONS,
    {
      fetchPolicy: "no-cache",
    }
  );

  const [getFailedByOrg] = useLazyQuery(GET_RECENTFAILED_BY_ORG, {
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (data && data.msgbox_Message) getFailedMsgs();
  }, [data, selectedOrg]);

  useEffect(() => {
    if (orgData) {
      let tempOrgs = [
        {
          label: "All Organisations",
          value: -1,
        },
      ];
      orgData.msgbox_Organisation.map((org: any) => {
        tempOrgs.push({
          label: org.Name,
          value: org.OrganisationId,
        });
      });
      setOrgs(tempOrgs);
    }
  }, [orgData]);

  async function getFailedMsgs() {
    if (selectedOrg.value === -1) {
      setTableData(mapMessagesToTableData(data.msgbox_Message));
    } else {
      const res = await getFailedByOrg({
        variables: { orgId: selectedOrg.value },
      });
      setTableData(mapMessagesToTableData(res.data.msgbox_Message));
    }
  }

  const handleSearch = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const text = e.target.value;
    setSearchText(text);

    // Get the current data source based on selected organisation
    let sourceData;
    if (selectedOrg.value === -1) {
      sourceData = data?.msgbox_Message || [];
    } else {
      const res = await getFailedByOrg({
        variables: { orgId: selectedOrg.value },
      });
      sourceData = res.data?.msgbox_Message || [];
    }

    if (sourceData.length > 0) {
      const filteredData = sourceData
        .filter((item: any) => {
          const searchStr = text.toLowerCase();
          const inboxName = item.Conversation?.Folder?.Inbox?.Name || "";
          const mobileNumber = item.Conversation?.Contact?.MobileNumber || "";
          const lastDigits = mobileNumber.slice(-3); // Get last 3 digits for search
          
          return (
            (item.Organisation?.Name || "").toLowerCase().includes(searchStr) ||
            item.MessageId.toString().includes(searchStr) ||
            (item.SendFailureReason || "").toLowerCase().includes(searchStr) ||
            (item.ExternalId || "").toLowerCase().includes(searchStr) ||
            inboxName.toLowerCase().includes(searchStr) ||
            lastDigits.includes(searchStr)
          );
        });
      setTableData(mapMessagesToTableData(filteredData));
    }
  };

  const refetchData = () => {
    refetch();
  };

  const selectStyle = {
    control: (provided: any) => ({
      ...provided,
      backgroundColor: "#033350",
      border: `1px solid ${Theme.styles.primary}`,
      color: Theme.styles.textColour2,
      borderColor: Theme.styles.secondary,
      maxWidth: 400,
      minWidth: 300,
      boxShadow: "none",
    }),
    input: (provided: any) => ({
      ...provided,
      // color: Theme.styles.textColour1, // Change the text color of the search input
      color: "#adb5bd",
      fontWeight: 400,
    }),
    singleValue: (provided: any) => ({
      ...provided,
      color: Theme.styles.textColour1, //textColor1
    }),
    menu: (provided: any) => ({
      ...provided,
      backgroundColor: Theme.styles.secondary, // primary
      border: `1px solid ${Theme.styles.primaryBold}`, //primary bold
      color: Theme.styles.textColour1, //textColor1
    }),
    menuList: (provided: any) => ({
      ...provided,
      backgroundColor: Theme.styles.primary, // primary
      border: `1px solid ${Theme.styles.primaryBold}`, //primary bold
      color: Theme.styles.textColour1, //textColor1
    }),
    option: (styles: any, { data, isDisabled, isFocused, isSelected }: any) => {
      return {
        ...styles,
        backgroundColor: isFocused ? Theme.styles.secondary : null,
        color: Theme.styles.textColour1, //textColor1
      };
    },
    multiValue: (styles: any) => {
      return {
        ...styles,
        backgroundColor: Theme.styles.secondary,
        color: "white",
      };
    },
    multiValueLabel: (styles: any) => ({
      ...styles,
      color: Theme.styles.textColour1, //textColor1
    }),
    multiValueRemove: (styles: any) => ({
      ...styles,
      color: Theme.styles.textColour1, //textColor1
      ":hover": {
        backgroundColor: Theme.styles.primary,
        color: "white",
      },
    }),
  };

  return (
    <React.Fragment>
      <Card>
        <CardHeader>
          <Row>
            <Col md={6}>
              <div className="mb-3">
                <h4 className="card-title">Recent Failed Messages</h4>
              </div>
            </Col>
            <Col md={6}>
              <div className="d-flex flex-wrap align-items-start justify-content-md-end mt-2 mt-md-0 gap-2 mb-3">
                <div>
                  <Link to="#" className="btn btn-light" onClick={refetchData}>
                    <i className="uil uil-refresh me-1"></i> Refresh
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </CardHeader>

        <CardBody>
          <PaginationProvider pagination={paginationFactory(pageOptions)}>
            {({ paginationProps, paginationTableProps }) => (
              <React.Fragment>
                <Row className="mb-2">
                  <Col md="4">
                    <div className="search-box me-2 mb-2 d-inline-block">
                      <div className="position-relative">
                        <Input
                          type="text"
                          className="form-control"
                          placeholder="Search..."
                          value={searchText}
                          onChange={handleSearch}
                        />
                        <i className="bx bx-search-alt search-icon" />
                      </div>
                    </div>
                  </Col>
                  <Col md="4">
                    <Select
                      styles={selectStyle}
                      placeholder="Filter Org"
                      options={orgs}
                      value={selectedOrg}
                      onChange={(e: any) => {
                        setSelectedOrg(e);
                      }}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xl="12">
                    <div className="table-responsive">
                      <BootstrapTable
                        bordered={false}
                        striped={false}
                        defaultSorted={defaultSorted}
                        classes="table align-middle table-nowrap"
                        headerWrapperClasses="thead-dark"
                        headerClasses="table-dark"
                        {...paginationTableProps}
                        keyField="Id"
                        columns={columns}
                        data={tableData}
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col className="inner-custom-pagination d-flex">
                    <div className="d-inline">
                      <SizePerPageDropdownStandalone {...paginationProps} />
                    </div>
                    <div className="text-md-right ms-auto">
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </Col>
                </Row>
              </React.Fragment>
            )}
          </PaginationProvider>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default RecentFailedMessages;
